import Button from "@/components/Button/Button"
import { MODALS } from "@/constants/modals"
import type { Round } from "@/types/roundTypes"
import { allowAttendOnlineLecture } from "@/utils/helpers"
import { coursesIcon, googleMeetIcon } from "@/utils/variables"
import { useStore } from "@/zustand/store"
import { Clock, ExternalLink } from "lucide-react"
import moment from "moment"
import { Col } from "react-bootstrap"
import { useTranslation } from "react-i18next"

export default function RoundLatestLecture({ round }: { round: Round }) {
  const latestLecture = round?.lectures?.[0]
  const { t } = useTranslation()

  const editModalState = useStore((store) => store.editModalState)

  if (!latestLecture) return null

  const allowAttend = true || allowAttendOnlineLecture(latestLecture, round)

  return (
    <Col md={12}>
      <div
        style={{
          border: "1px solid #e0e6ed",
          background: "#fff",
          boxShadow: "0 2px 10px rgba(0,0,0,0.02)",
          transition: "all 0.3s ease",
          borderRadius: "16px",
          padding: "20px",
        }}
        className="d-flex align-items-center justify-content-between gap-3 flex-wrap flex-md-nowrap"
      >
        <div className="d-flex align-items-center gap-3">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "50px",
              height: "50px",
              background: "rgba(36, 59, 120, 0.05)",
              color: "var(--primary)",
            }}
          >
            {coursesIcon}
          </div>
          <div className="d-flex flex-column">
            <h6
              onClick={() => {
                if (allowAttend) {
                  editModalState(MODALS.lecture.attend, {
                    lecture: latestLecture,
                    round,
                  })
                }
              }}
              style={
                allowAttend
                  ? {
                      cursor: "pointer",
                      textDecoration: "underline",
                    }
                  : {}
              }
              className="text-dark fw-bold m-0 text-capitalize fs-5"
            >
              {round?.name}
              {round?.google_meet_link && allowAttend && (
                <ExternalLink size={16} className="ms-2" />
              )}
            </h6>
            <p className="text-muted small m-0">{round?.course?.title}</p>
          </div>
        </div>

        <div className="d-flex align-items-center gap-4 flex-wrap flex-md-nowrap">
          <div className="d-flex align-items-center gap-2 text-muted">
            <Clock size={18} className="text-primary opacity-75" />
            <span className="fw-semibold">
              {t("homePage.latestLectures.startsAt")}{" "}
              {moment(latestLecture?.start_time).format("hh:mm A")}
            </span>
          </div>

          <div style={{ minWidth: "160px" }}>
            <Button
              onClick={() => {
                if (allowAttend) {
                  editModalState(MODALS.lecture.attend, {
                    lecture: latestLecture,
                    round,
                  })
                }
              }}
              icon={googleMeetIcon}
              fixedWidth
              className="w-100 rounded-pill py-2"
              variant="primary"
            >
              {t("homePage.latestLectures.joinNow")}
            </Button>
          </div>
        </div>
      </div>
    </Col>
  )
}
